<template>
  <div class="mt-2">
    <div v-if="content">
      <b-button v-b-toggle.sidebar-help variant="link">
        <i class="fa fa-question-circle help-icon text-yellow"></i>
      </b-button>
      <b-sidebar
        id="sidebar-help"
        :title="content.title"
        right
        shadow
        :width="width"
      >
        <div v-if="content.instructions" class="px-3 mb-3">
          <h5>Instructions</h5>
          <p
            v-for="(paragraph, paragraphIndex) in content.instructions"
            :key="paragraphIndex"
          >
            {{ paragraph }}
          </p>
        </div>

        <div v-if="content.qa" class="px-3 mb-3">
          <h5>Q&A</h5>
          <div v-for="(item, itemIndex) in content.qa" :key="itemIndex">
            <b-button
              v-b-toggle="`qa-${itemIndex}`"
              variant="text"
              class="pl-0 w-100 text-left"
            >
              {{ item.q }}
              <b-icon-chevron-down class="when-closed float-right" />
              <b-icon-chevron-up class="when-open float-right" />
            </b-button>

            <b-collapse
              :id="`qa-${itemIndex}`"
              accordion="my-accordion"
              role="tabpanel"
            >
              <div v-if="Array.isArray(item.a)">
                <p
                  v-for="(paragraph, paragraphIndex) in item.a"
                  :key="paragraphIndex"
                  v-html="paragraph"
                >
                  {{ paragraph }}
                </p>
              </div>
              <p v-else>
                {{ item.a }}
              </p>
            </b-collapse>
          </div>
        </div>

        <div class="px-3 mb-3">
          <h5>Related Media content</h5>
          <div class="mb-2">
            <a
              href="https://youtu.be/iaINSE6FYI8"
              target="_blank"
              class="text-black"
            >
              How to work with Bonacube App? (Video 4:59)
            </a>
          </div>
          <div class="mb-2">
            <a
              href="https://we.tl/t-vYmGMH8gqi"
              target="_blank"
              class="text-black"
            >
              The art of event planning - A guide for better event planning
              <br />(Download PDF via WeTransfer)
            </a>
          </div>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import { BIconChevronDown, BIconChevronUp } from 'bootstrap-vue'
import HelpContent from '@/assets/json/help-content.json'
export default {
  components: {
    BIconChevronDown,
    BIconChevronUp
  },
  data: () => ({
    windowInnerWidth: window.innerWidth,
    instructions: HelpContent
  }),
  computed: {
    content() {
      const currentPath = this.$route.path
      const instructions = this.instructions.find((i) => i.path === currentPath)
      return instructions
    },
    width() {
      let width
      if (this.windowInnerWidth >= 800) {
        width = '33vw'
      }
      if (this.windowInnerWidth < 800) {
        width = '50vw'
      }
      if (this.windowInnerWidth < 500) {
        width = '100vw'
      }
      return width
    }
  }
}
</script>

<style scoped>
.help-icon {
  font-size: 1.2rem;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
